import React from 'react'
import Link from 'gatsby-link'
import Arrow from './arrow'

const ArrowButton = ({ style, route, text }) =>
  route.indexOf('http') >= 0 ? (
    <RemoteRoute style={style} route={route} text={text} />
  ) : (
    <LocalRoute style={style} route={route} text={text} />
  )

const LocalRoute = ({ style, route, text }) => (
  <div style={style}>
    <Link style={rowStyle} to={route}>
      <div style={textStyle}>{text}</div>
      <Arrow style={{ paddingLeft: '.75rem', width: '3rem', maxHeight: 14 }} />
    </Link>
  </div>
)

const RemoteRoute = ({ style, route, text }) => (
  <div style={style}>
    <div style={rowStyle}>
      <a href={route} target={'_blank'}>
        <div
          style={{
            fontWeight: 600,

            fontSize: '14px',
            display: 'inline-block',
            height: '28px',
            lineHeight: '28px',
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </div>
        <Arrow
          style={{ paddingLeft: '.75rem', width: '3rem', maxHeight: 14 }}
        />
      </a>
    </div>
  </div>
)

export default ArrowButton

const textStyle = {
  fontWeight: 600,
  fontSize: '14px',
  height: '28px',
  lineHeight: '28px',
  marginRight: '0.5rem',
}

const rowStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
}



// WEBPACK FOOTER //
// ./src/components/shared/arrowButton.js